import { apiQueryKeys } from '@/services/apis/apiQueryKeys';
import { useGlobalStore } from '@/stores/store';
import { getGlobalStore } from '@/utils/store';
import { useQueryClient } from '@tanstack/react-query';
import { useShallow } from 'zustand/react/shallow';

export function useLogout() {
  const queryClient = useQueryClient();
  const { customerId, feedbackCardAddressSearchVisible } = useGlobalStore(
    useShallow((store) => ({
      customerId: store.authStore.customerId,
      feedbackCardAddressSearchVisible:
        store.addressStore.feedbackCardAddressSearchVisible,
    }))
  );

  const {
    setLogout,
    setFeedbackCardAddressSearchVisible,
    setFeedbackCardRecentSearchVisible,
  } = getGlobalStore();
  const handleLogout = () => {
    queryClient.removeQueries({
      queryKey: apiQueryKeys.me(customerId),
      exact: true,
    });

    if (feedbackCardAddressSearchVisible === 'already-has-service') {
      setFeedbackCardAddressSearchVisible(null);
      setFeedbackCardRecentSearchVisible(null);
    }

    setLogout();
  };

  return handleLogout;
}
